import { effects } from 'redux-saga'
import callWithHmac from '../effects/callWithHmac'

import { receiveInvoices } from '../../modules/invoice'
import { begin, end } from '../../modules/loading'

export default function* loadSaga(invocation, { payload = {} }) {
  try {
    yield effects.put.resolve(begin('invoices', payload.invoiceIds))

    const result = yield effects.call(
      callWithHmac,
      invocation.getInvoices,
      payload.invoiceIds,
    )

    yield effects.put.resolve(receiveInvoices(result.invoices))
  } finally {
    yield effects.put.resolve(end('invoices', payload.invoiceIds))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/invoice/load.js